import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import saveAs from 'file-saver';
import { PropertyItemDocumentPurposeEnum } from '../../Models/Interfaces/PropertyItemDocumentPurposeEnum';
import { BlobResponse, PropertyItemDocumentPurposeEnumHelper } from '../../Models/OtherClasses';
import { ConfigService } from "../../Services/ConfigService";
import { PropertyItemDocumentService } from '../../Services/Custom/ServicePropertyItemDocument';
import { DialogService } from '../../Services/DialogService';

@Component({
	selector: 'ImagePopUp',
	templateUrl: 'ImagePopUp.html',

})
export class ImagePopUpComponent {

	file: BlobResponse;
	dataSrc: string;
	allDocCol: TooBig4Car.Logic.PropertyItemDocument[] = [];
	myIndex: number = 0;

	constructor(
		public configData: ConfigService,
		private myPropertyItemDocumentService: PropertyItemDocumentService,
		private dialogService: DialogService,
		private activeModal: NgbActiveModal) {

	}

	setBlob(iBlob: BlobResponse, idx: number, col: TooBig4Car.Logic.PropertyItemDocument[]) {
		this.myIndex = idx;
		this.allDocCol = col;
		this.loadOverlay(idx);
		this.file = iBlob;
		this.configData.blobToBase64(iBlob.blob)
			.then(dataStr => {
				this.dataSrc = dataStr;
			});
	}
	closePopUp() {
		this.activeModal.close();
	}

	downloadDoc() {
		if (this.file) {
			saveAs(this.file.blob, this.file.fileName);
		}
	}

	allowDelete = false;

	get deleteAllowed(): boolean {
		return this.allowDelete && !!this.allDocCol?.[this.myIndex]?.APICanIDeleteThis;
	}
	deleteDoc() {
		if (this.deleteAllowed) {
			var doc = this.allDocCol[this.myIndex];
			this.dialogService.confirm('Are you sure you want to delete this photo?')
				.then(result => {
					if (result) {
						this.myPropertyItemDocumentService.deleteItem(doc.PropertyItemDocumentID)
							.subscribe(() => {
								this.activeModal.close(doc);
							});
					}
				});
		}
	}

	
	get nextAllowed(): boolean {
		return this.getListLength() > 1;
	}
	next() {
		if (this.nextAllowed) {
			this.loadIDX(this.myIndex + 1);
		}
	}

	get prevAllowed(): boolean {
		return this.getListLength() > 1;
	}
	prev() {
		if (this.prevAllowed) {
			this.loadIDX(this.myIndex - 1);
		}
	}

	getListLength(): number {
		return this.allDocCol?.length ?? 0;
	}
	overlayText = '';
	loadOverlay(newIDX: number) {
		this.overlayText = '';
		var myDoc: TooBig4Car.Logic.PropertyItemDocument = null;
		if (newIDX >= 0 && newIDX < this.getListLength()) {
			myDoc = this.allDocCol[newIDX];
		}
		if (myDoc && this.configData.IsEmptyGuid(myDoc.PickupDeliveryItemID)) {
			this.overlayText = myDoc.OverlayText;
		}
	}
	
	loadIDX(newIDX: number) {
		this.overlayText = '';
		var innerIDX = newIDX;
		var listLength = this.getListLength();
		if (listLength > 1) {
			if (newIDX < 0) {
				innerIDX = listLength - 1;
			} else if (newIDX > listLength - 1) {
				innerIDX = 0;
			}
		} else {
			innerIDX = -1;
		}
		var thisHolder = this;
		if (innerIDX >= 0) {
			this.myPropertyItemDocumentService.downloadDoc(this.allDocCol[innerIDX].PropertyItemDocumentID)
				.subscribe(file => {
					thisHolder.setBlob(file, innerIDX, this.allDocCol);
					thisHolder.loadOverlay(innerIDX);
				});
		}
	}
}
